export default {"src":"/_next/static/image/public/blankly-black.c8ffff686b6bcd1a00204cddf3986cb9.svg","height":64,"width":210};